module.exports = __webpack_public_path__ + "media/images/admin/icon/icon_image-67891f38e7284eb5c8a56cea9e617bfe.svg";